import { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useStore } from "../../contexts/StoreContext";

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

interface LandingPageGuardProps {
  allowedPages: string[];
  fallbackPath: string;
  children?: ReactNode;
}

function LandingPageGuard({ allowedPages, fallbackPath, children }: LandingPageGuardProps) {
  const location = useLocation();
  const { isInitialNavigation } = useStore();

  if (isInitialNavigation) {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const currentPage = pathSegments[pathSegments.length - 1] ?? "";
    const [productSegment, maybeApplicationUuid] = pathSegments;
    const hasScopedApplicationPath =
      [
        "personal-loan",
        "olb-personal-loan",
        "credit-card",
        "olb-credit-card",
        "auto-loan",
        "olb-auto-loan",
      ].includes(productSegment ?? "") &&
      Boolean(maybeApplicationUuid) &&
      UUID_PATTERN.test(maybeApplicationUuid);

    if (!allowedPages.includes(currentPage) && !hasScopedApplicationPath) {
      const fallbackWithSearch = location.search
        ? `${fallbackPath}${location.search}`
        : fallbackPath;
      return <Navigate to={fallbackWithSearch} replace />;
    }
  }

  return children ? <>{children}</> : <Outlet />;
}

export { LandingPageGuard };
